import { observer } from 'mobx-react'
import { useUserStore } from '../../store/user.store'
import Unauthorized from '../../pages/Unauthorized'

// A reusable wrapper component
const ProtectedSubadminComponent = observer( ( { permissionKey, children } ) => {
    const UserStore = useUserStore()

    const permission = UserStore.getUser.user_role?.toLowerCase() === "admin" || ( UserStore.getUser?.user_permissions?.[permissionKey] ?? false )

    if ( !permission ) {
        return <Unauthorized />
    }

    return children
} )

export default ProtectedSubadminComponent